import React, { memo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Spinner } from "react-bootstrap";
import SimpleMessageDialog from "../../components/SimpleMessageDialog/SimpleMessageDialog";
import { cartAnimation } from "../../helper/cart-animation";
import { CURRENCY } from "../../helper/constant";
import t from "../../i18n/translate";
import expressService from "../../services/expressService";
import itemToCartService from "../../services/itemToCartService";
import FlagIconFactory from "react-flag-icon-css";
import moment from "moment";
import { compDate } from "../../constants/Constant";
import { Favorite } from "@material-ui/icons";
import { CartBuy, CartIcon } from "../../components/AllSvgIcon";
import LazyLoad from "react-lazyload";
import { useFavorites } from "../../contexts/favorites/use-favorites";
import { useCart } from "../../contexts/cart/use-cart";
import {
	BannerWrapper,
	BrandLogoWrapper,
	FavoriteItemContent,
	ImageContent,
	ItemInfo,
	ItemTitle,
	PriceAndButtonActions,
	ProductPrice,
	ProductPriceWrapper,
	PromoPrice,
	WeightAndCountryWrapper,
	IconCartContainer,
} from "./Favorites.style";
import { Tooltip } from "@material-ui/core";
import { QuantityModifier } from "../../components/QuantityModifier/QuantityModifier";
import { logAddToCart, logRemoveFromCart, logRemoveFromWishlist } from "../../services/googleAnalytics";

function FavoriteItem({
	onClick,
	data,
	itemId,
	sku,
	name,
	itemRefId,
	imgUrl,
	countryCode,
	price,
	salePrice,
	promo,
	promoPrice,
	promoStartDate,
	promoEndDate,
	promoProduct = false,
	outOfStock,
	isSameDay,
	isAvailableTomorrow,
	isAvailableTomorrowExpress,
	isShopOpen,
	isShopNormalOpen,
	notificationId,
	weight,
	brandId,
	brands,
	type,
	cartType,
	color,
	loader,
}) {
	const { removeItemFromFavorites, favRemoveLoading } = useFavorites();

	const { fetchOrderItems, resetCart, getItem, isInCart, items } = useCart();

	const dayNumber = moment().isoWeekday();
	const FlagIcon = FlagIconFactory(React, { useCssModules: false });

	const history = useHistory();

	// Simple Message Dialog
	const [showError, setShowError] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showHeaderDialog, setShowHeaderDialog] = useState(false);
	const [isConfirmButton, setIsConfirmButton] = useState(false);
	const [confirmLabel, setConfirmLabel] = useState("OK");
	const [dialogLoading, setDialogLoading] = useState(false);
	const [closeLabel, setCloseLabel] = useState("CLOSE");
	const [dialogHeaderLabel, setDialogHeaderLabel] = useState("Error");
	const [errorLog, setErrorLog] = useState(null);
	const [simpleDialogBackdrop, setSimpleDialogBackdrop] = useState(true);
	const [isLoading, setIsLoading] = useState(false);

	const extraBrands = useSelector((state) => state.expressReducer.extraBrands);

	// Simple Dialog
	const closeSimpleDialog = async () => {
		if (errorLog?.error && errorLog?.error_type === "paymentInProgress") {
			setDialogLoading(true);
			const orderLockResp = await expressService.orderLocked(cartType);
			if (orderLockResp.status === 200) {
				let quantity = isInCart(itemId) ? getItem(itemId).quantity + 1 : 1;
				setTimeout(async () => {
					const itemResp = await itemToCartService.addItem(
						itemId,
						cartType,
						quantity
					);

					if (itemResp.success) {
						await fetchOrderItems(cartType);
					} else {
						setErrorMessage(itemResp.message);
					}

					setShowError(false);
					setDialogLoading(false);
				}, 250);
			} else {
				alert(t("shop_item_update_error"));
				setShowError(false);
				setDialogLoading(false);
			}
		} else {
			setShowError(false);
		}
	};

	const onConfirm = () => {
		if (errorLog.error && errorLog.error_type === "multiSupplier") {
			handleOverWriteCart();
		} else if (errorLog.error && errorLog.error_type === "paymentInProgress") {
			window.location.href = "/checkout";
		}
	};

	const handleOverWriteCart = async () => {
		setDialogLoading(true);

		await resetCart();

		setTimeout(async () => {
			const itemResp = await itemToCartService.addItem(itemId, cartType);

			if (itemResp.success) {
				await fetchOrderItems(cartType);
			} else {
				setErrorMessage(itemResp.message);
			}

			setShowError(false);
			setDialogLoading(false);
		}, 250);
	};

	const handleAddClick = async (e) => {
		e.stopPropagation();

		if (isLoading) return;

		setSimpleDialogBackdrop(true);

		if (!localStorage.getItem("user") || !localStorage.getItem("token")) {
			document.getElementById("joinBTn").click();
			window.trigger = "add to favorites";
		} else {
			let itemQuantity = 1;
			setIsLoading(true);
			// If user click on button [Add to cart]
			if (!isInCart(itemId)) {
				cartAnimation(e);
			}
			// if user click on button increase item quantity
			else {
				itemQuantity = (await getItem(itemId).quantity) + 1;
			}

			const itemResp = await itemToCartService.addItem(
				itemId,
				cartType,
				itemQuantity
			);
			if (itemResp.success) {
				logAddToCart(itemResp.data)
				fetchOrderItems(cartType);
			} else {
				if (
					typeof itemResp.error === "string" &&
					itemResp.error === "multiSupplier"
				) {
					setIsConfirmButton(true);
					setConfirmLabel(t("shop_add_item_to_cart_different_shop_error_remove"));
					setCloseLabel(t("shop_add_item_to_cart_different_shop_error_cancel"));
					setDialogHeaderLabel(
						t("shop_add_item_to_cart_different_shop_error_title")
					);
					setShowHeaderDialog(true);
					setErrorLog({
						error: true,
						error_type: "multiSupplier",
					});
				} else if (itemResp.error && itemResp.error === "paymentInProgress") {
					setIsConfirmButton(true);
					setConfirmLabel(t("shop_popup_continue_payment_button"));
					setCloseLabel(t("shop_popup_cancel_payment_button"));
					setDialogHeaderLabel(t("shop_popup_payment_locked_label"));
					setShowHeaderDialog(true);
					setErrorLog({ error: true, error_type: "paymentInProgress" });
					setSimpleDialogBackdrop("static");
				} else {
					setErrorLog({ error: false });
				}
				setErrorMessage(itemResp.message);
				setShowError(true);
			}
			setIsLoading(false);
		}
	};

	const handleRemoveClick = async (e) => {
		e.stopPropagation();
		let itemResp = null;

		// if (!localStorage.getItem("user")) {
		//   onCartClick();
		// }
		// else{
		setIsLoading(true);
		// Remove item from cart When user click on button decrease item quantity <= 1
		if (getItem(data.item_id).quantity === 1) {
			itemResp = await itemToCartService.removeItemFromCart(
				getItem(data.item_id),
				cartType
			);
			logRemoveFromCart(data,1)

			if (items.length <= 1) {
				resetCart();
			}
		}
		// When user click on button decrease item quantity
		else {
			itemResp = await itemToCartService.addItem(
				data.item_id,
				cartType,
				getItem(data.item_id).quantity - 1
			);
			logRemoveFromCart(itemResp.data,0)
		}

		if (itemResp.success) {
			fetchOrderItems(cartType);
		} else {
			setShowError(true);
			setErrorMessage(itemResp.message);
		}
		setIsLoading(false);
		// }
	};
	const handleInputUpdateQuantity = async (data, quantity) => {
		if (parseInt(quantity) >= 1) {
			setIsLoading(true);
			const itemResp = await itemToCartService.addItem(
				data.item_id,
				cartType,
				parseInt(quantity)
			);
			if (itemResp.success) {
				fetchOrderItems(cartType);
			} else {
				if (
					typeof itemResp.error === "string" &&
					itemResp.error === "multiSupplier"
				) {
					setIsConfirmButton(true);
					setConfirmLabel(t("shop_add_item_to_cart_different_shop_error_remove"));
					setCloseLabel(t("shop_add_item_to_cart_different_shop_error_cancel"));
					setDialogHeaderLabel(
						t("shop_add_item_to_cart_different_shop_error_title")
					);
					setShowHeaderDialog(true);
				}
				setErrorMessage(itemResp.message);
				setShowError(true);
			}
			setIsLoading(false);
		}
	};

	const onItemClick = () => {
		history.push(`/product/${itemRefId}`);
	};

	const getBrandLogo = (id) => {
		var b = brands.filter((elem) => {
			return elem.brand_id === id;
		});
		return b.length !== 0 ? b[0].logo : null;
	};

	return (
		<>
			{favRemoveLoading[itemId] ? (
				loader("relative")
			) : (
				<FavoriteItemContent
					// onClick={onItemClick}
					onClick={onClick}
					className={`product-card ${outOfStock ? "out-of-stock" : ""} ${
						cartType === "express" && "express"
					}`}
				>
					<Tooltip title={t("favorites_remove_from_tooltip")}>
						<Button
							variant="light"
							size="sm"
							className="btn-remove-favorite"
							onClick={(e) => {
								e.stopPropagation();
								removeItemFromFavorites({ type: type, item_id: itemId}, notificationId = (notificationId !== undefined && notificationId !== null) ? notificationId :null );
								logRemoveFromWishlist(data)
							}}
							tabIndex={3}
						>
							<Favorite className="favorite-icon" fontSize="small" />
						</Button>
					</Tooltip>
					<ImageContent>
						<BrandLogoWrapper>
							<LazyLoad height={140}>
								{getBrandLogo(brandId) !== null && getBrandLogo(brandId) !== "" ? (
									<img
										src={getBrandLogo(brandId)}
										className={promoProduct ? "brand-promo" : "brand-image"}
										alt={name}
										onError={(e) => {
											e.target.onerror = null;
											e.target.src = require("../../assets/icons/delishop_logo2.svg");
										}}
									/>
								) : (
									<img
										src={require("../../assets/icons/delishop_logo2.svg")}
										className={promoProduct ? "brand-promo" : "brand-image"}
										alt={name}
									/>
								)}
							</LazyLoad>
						</BrandLogoWrapper>
						<img
							src={imgUrl ?? require("../../assets/images/delishop-favicons.png")}
							alt="Favorite"
							loading="lazy"
							className="product-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = require("../../assets/images/delishop-favicons.png");
              }}
						/>
					</ImageContent>
					<ItemInfo>
						<BannerWrapper>
							{cartType !== "express" ? (
								isSameDay && dayNumber !== 7 && isShopNormalOpen ? (
									!outOfStock ? (
										<span className="sameDay-banner">{t("shop_item_get_same_day")}</span>
									) : (
										<span className="out-of-stock-banner">
											{t("shop_item_out_of_stock")}
										</span>
									)
								) : !outOfStock ? (
									isAvailableTomorrow ? (
										<span className="tomorrow-banner full-width">
											{t("shop_item_get_tomorrow")}
										</span>
									) : null
								) : (
									<span className="out-of-stock-banner">
										{t("shop_item_out_of_stock")}
									</span>
								)
							) : isSameDay && dayNumber !== 7 && isShopOpen ? (
								!outOfStock ? (
									<span className="sameDay-banner express">
										{t("shop_item_get_same_day")}
									</span>
								) : (
									<span className="out-of-stock-banner">
										{t("shop_item_out_of_stock")}
									</span>
								)
							) : !outOfStock ? (
								isAvailableTomorrowExpress ? (
									<span className="tomorrow-banner full-width">
										{t("shop_item_get_tomorrow")}
									</span>
								) : null
							) : (
								<span className="out-of-stock-banner">
									{t("shop_item_out_of_stock")}
								</span>
							)}

							{/* Promotion Banner */}
							{promo === 1 &&
							!outOfStock &&
							promoStartDate !== null &&
							promoEndDate !== null &&
							compDate(promoStartDate, promoEndDate) ? (
								<span className={`promo-banner ${dayNumber === 7 ? "custom" : ""}`}>
									{t("shop_item_promo_label")}
								</span>
							) : null}
						</BannerWrapper>
						<ItemTitle title={name}>{name}</ItemTitle>
						<WeightAndCountryWrapper>
							<span className="weight">{weight}</span>
							{countryCode && (
								<span className="country-label">
									<FlagIcon code={countryCode.toLowerCase()} />
								</span>
							)}
						</WeightAndCountryWrapper>
						<PriceAndButtonActions>
							<ProductPriceWrapper>
								{price !== salePrice && (
									<ProductPrice
										className={
											promo === 1 &&
											promoStartDate !== null &&
											promoEndDate !== null &&
											compDate(promoStartDate, promoEndDate)
												? `strike-through ${cartType}`
												: ""
										}
									>
										<meta itemProp={"oldPriceCurrency"} content={"USD"} />
										<span
											itemProp={"oldPrice"}
											content={parseFloat(salePrice).toFixed(2)}
											className={`${cartType} ${promoProduct ? "promo-price" : ""}`}
										>
											{CURRENCY}
											{parseFloat(salePrice).toFixed(2)}
										</span>
									</ProductPrice>
								)}
								{promo === 1 &&
									promoStartDate !== null &&
									promoEndDate !== null &&
									compDate(promoStartDate, promoEndDate) && (
										<PromoPrice className={promoProduct ? "promo-price" : ""} itemscope itemtype="https://schema.org/PriceSpecification">
											<meta itemProp={"@type"} content={"UnitPriceSpecification"} />
											<meta itemProp={"priceType"} content={"https://schema.org/ListPrice"} />
											<meta itemProp={"priceCurrency"} content={"USD"} />
											<span
												itemProp={"price"}
												content={parseFloat(promoPrice).toFixed(2)}
												className={`${cartType} ${
													compDate(promoStartDate, promoEndDate) ? "promo-price" : ""
												}`}
											>
												{CURRENCY}
												{parseFloat(promoPrice).toFixed(2)}
											</span>
											<meta itemProp="priceValidUntil" content={promoEndDate} />
										</PromoPrice>
									)}
							</ProductPriceWrapper>
							{!isInCart(itemId) ? 
								cartType !== "express" ? (
									<Button
										variant="outline-light"
										size="sm"
										disabled={outOfStock || (!isShopOpen && cartType === "express")}
										className={`d-flex align-items-center btn-add-to-cart ${cartType}`}
										style={{ background: color }}
										onClick={(e) => !isLoading && handleAddClick(e)}
									>
										{isLoading ? (
											<Spinner animation="border" size="sm" />
										) : (
											<>
												<IconCartContainer>
													<CartBuy style={{ height: "14px", fill: "#fff" }} />
												</IconCartContainer>
												<span className="ml-1">Buy</span>
											</>
										)}
									</Button>
								):(
									<Button
										variant="outline-light"
										size="sm"
										disabled={outOfStock || (!isShopOpen && cartType === "express")}
										className={`d-flex align-items-center btn-add-to-cart ${cartType}`}
										style={{ background: color }}
										onClick={(e) => !isLoading && handleAddClick(e)}
									>
										{isLoading ? (
											<Spinner animation="border" size="sm" />
										) : (
											<>
												<IconCartContainer>
													<CartBuy style={{ height: "14px", fill: "#fff" }} />
												</IconCartContainer>
												<span className="ml-1">Buy</span>
											</>
										)}
									</Button>
								)
							: cartType !== "express" ? (
								<div onClick={(e) => e.stopPropagation()}>
									<QuantityModifier
										className={`pr${itemId} ${cartType}`}
										value={getItem(itemId).quantity}
										onDecrement={handleRemoveClick}
										onIncrement={handleAddClick}
										onUpdate={(quantity) => {
											handleInputUpdateQuantity(data, quantity);
										}}
										promoProduct={promoProduct}
										isLoading={isLoading}
										// variant={variant}
									/>
								</div>
							):(
								<div onClick={(e) => e.stopPropagation()}>
									<QuantityModifier
										className={`pr${itemId} ${cartType}`}
										value={getItem(itemId).quantity}
										onDecrement={handleRemoveClick}
										onIncrement={handleAddClick}
										onUpdate={(quantity) => {
											handleInputUpdateQuantity(data, quantity);
										}}
										promoProduct={promoProduct}
										isLoading={isLoading}
										// variant={variant}
									/>
								</div>
							)
							}
						</PriceAndButtonActions>
					</ItemInfo>
				</FavoriteItemContent>
			)}

			<SimpleMessageDialog
				show={showError}
				message={errorMessage}
				showHeader={showHeaderDialog}
				closeLabel={closeLabel}
				confirmLabel={confirmLabel}
				headerLabel={dialogHeaderLabel}
				isConfirmButton={isConfirmButton}
				onClose={closeSimpleDialog}
				onConfirm={onConfirm}
				backdrop={simpleDialogBackdrop}
				loading={dialogLoading}
				cartType={cartType}
			/>
		</>
	);
}

export default memo(FavoriteItem);
